/** Inline budget guidance is deliberately independent of launcher recovery. */
export type BudgetFailureKind = "action_contract" | "meta_rejection" | "integration_rejection" | "uncertain" | "not_sent";

export function budgetFailureGuidance(kind: BudgetFailureKind) {
  switch (kind) {
    case "action_contract": return {
      title: "Budget update could not be submitted",
      reason: "The integration could not submit the budget update to Meta.",
      nextAction: "Contact support to correct the integration. Changing Meta settings will not fix this submission error.",
    };
    case "meta_rejection": return {
      title: "Meta rejected the budget update",
      reason: "Meta returned a rejection for this budget update.",
      nextAction: "Check the budget and any restrictions on this entity in Meta Ads Manager before deciding on another edit.",
    };
    case "integration_rejection": return {
      title: "Budget update could not complete",
      reason: "The integration rejected the budget request without a confirmed Meta rejection.",
      nextAction: "Contact support to check the connected account and integration.",
    };
    case "not_sent": return {
      title: "Budget update not sent",
      reason: "The budget request did not pass the account, entity, or budget checks.",
      nextAction: "Refresh the page and check your account access and the controlling daily-budget level.",
    };
    case "uncertain": return {
      title: "Budget update outcome is uncertain",
      reason: "Meta may have received the budget update, but its result could not be confirmed.",
      nextAction: "Do not repeat this update. Inspect the current budget in Meta Ads Manager before deciding whether another edit is needed.",
    };
  }
}
